import React, { useEffect, useState } from "react";
import api from "../../api";
import ChartInfoPopup from "./ChartInfoPopup";

const ModelUsageTable = () => {
  const [modelData, setModelData] = useState([]);
  const [totalUsage, setTotalUsage] = useState(0);

  useEffect(() => {
    const fetchModelUsage = async () => {
      try {
        const token =
          localStorage.getItem("access_token") ||
          sessionStorage.getItem("access_token");
        const config = {
          headers: { Authorization: `Bearer ${token}` },
        };

        const response = await api.get(
          `${process.env.REACT_APP_API_URL}/chat/model-usage`,
          config
        );

        const { models, totalPercentage } = response.data;

        // Map both generic and original names
        const formattedData = models.map((item) => ({
          genericName: item.model, // backend now returns generic name
          originalName: item.original_name || "-", // in case backend sends original name
          value: parseFloat(item.percentage),
        }));

        // console.log("✅ Fetched total percentage:", totalPercentage);

        setModelData(formattedData);
        setTotalUsage(totalPercentage);
      } catch (err) {
        console.error("❌ Failed to fetch model usage", err);
      }
    };

    fetchModelUsage();
  }, []);

  return (
    <div className="chart-card p-3 shadow-sm rounded mb-4 d-flex flex-column refresh-prompts">
      <div className="d-flex align-items-center gap-2 mb-3">
        <h5 className="fw-semibold m-0">
          <span className="border-start border-4 ps-2 ak-text-lg d-flex align-content-center ">
            Model Usage
          </span>
        </h5>

        <div className="chart-info-anchor">
          <ChartInfoPopup text="Displays the percentage distribution of each model used on the platform. This helps track popularity, usage trends, and resource allocation." />
        </div>
      </div>

      <div className="mb-1 ak-text-md">
        <strong>Total Usage:</strong> {totalUsage}%
      </div>

      {/* Scrollable table container */}
      <div
        style={{
          height: "300px",
          width: "100%",
          // marginTop: "auto",
          overflowY: "auto",
        }}
      >
        <table className="table table-striped table-bordered table-sm mb-0 ak-text-md text-center">
          <thead className="table-light">
            <tr>
              <th className="border">Generic Name</th>
              <th>Usage (%)</th>
            </tr>
          </thead>
          <tbody>
            {modelData.map((entry, index) => (
              <tr key={index}>
                <td title={entry.genericName}  className="border">{entry.genericName}</td>
                <td className="border">{entry.value}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ModelUsageTable;
